import React from 'react';

import Modal from "../../../../component/modal/ModalTemplate";

import * as stringUtil from '../../../../util/stringUtil';
import * as apiUtil from "../../../../util/apiUtil";
import Loading from "../../../../component/loading/Loading";
import PackageHistoryTermsModal from "./PackageHistoryTermsModal";

class PackagePaymentUsageModal extends React.Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.getType = this.getType.bind(this);
        this.handleRefund = this.handleRefund.bind(this);
        this.setShowTermsModal = this.setShowTermsModal.bind(this);

        this.state = {
            loading: false,
            showTermsModal: false,
        }
    }


    setLoading(loading) {
        this.setState({ loading: loading });
    }

    setShowTermsModal(showTermsModal) {
        this.setState({ showTermsModal: showTermsModal });
    }

    getType(type) {
        switch (type) {
            case 'M':
                return '사용';
            case 'R':
                return '복구';
            case 'P':
                return '충전';
            case 'F':
                return '환불';
            case 'N':
                return '미발송 복구';
            case 'C':
                return '일반포인트 전환';
            case 'X':
                return '소멸';
            default:
                return 'N/A';
        }
    }

    handleRefund() {
        if (! window.confirm("환불 신청 하시겠습니까?")) return;

        /* 신용카드, 실시간 계좌이체 환불 */
        const { paymentInfo, handleSuccessModal, handleClose, handleFailModal } = this.props;

        /*환불 금액이 부족할때 나오는 모달 창*/
        if(Math.floor(paymentInfo.balance - (paymentInfo.balance * 0.1 + Math.floor(paymentInfo.amount* 1.1) * 0.03 + 500)) < 5000) {
            handleFailModal();
            handleClose();
            return;
        }

        if (paymentInfo.paymethod === '무통장입금') {
            const { handleAccountInfoUploadModal } = this.props;
            handleAccountInfoUploadModal();
        } else {
            let data = new FormData();
            data.append('cashPaymentId', paymentInfo.uid);

            const url = paymentInfo.useStatus === '패키지' ? '/api/cash/payment/refund/package' : '/api/cash/payment/refund';

            apiUtil.asyncRequest({
                setLoading: this.setLoading,
                url: url,
                method: apiUtil.requestMethod.POST,
                data: data,
                isFile: true,
                success: (result) => {
                    handleSuccessModal();
                    handleClose();
                }
            })
        }
    }

    render() {
        const { loading, showTermsModal } = this.state;
        const { isOpen, handleClose, usageList, paymentInfo } = this.props;
        const { getType } = this;
        const { handleRefund, setShowTermsModal } = this;

        const refundAmount = Math.max(Math.floor(paymentInfo.balance - (paymentInfo.balance * 0.1 + Math.floor(paymentInfo.amount * 1.1) * 0.03 + 500)), 0);
        return (
            <Modal
                open={isOpen}
                handleClose={handleClose}
                modalTitle="이용 내역"
                className="react-full-modal"
            >
                <Loading loading={loading} />
                <div className='modal-body'>
                    { paymentInfo.useStatus !== '패키지' ? (
                        paymentInfo.refundable && Math.floor(paymentInfo.balance - (paymentInfo.balance * 0.1 + Math.floor(paymentInfo.amount * 1.1) * 0.03 + 500)) >= 5000 && (
                                <div className="info-content-item shadow">
                                    <ol className="fs-6 mb-2 fw-modal fs-4 ps-4 ps-sm-5">
                                        <li>추가 이용을 희망하지 않는 경우, 잔여 포인트는 환불이 가능합니다.</li>
                                        <li>환불은 내부 산정식을 기준으로 진행되며, 산정식에 대한 자세한 사항은 이용약관에서 확인이 가능합니다.</li>
                                        <li>환불 가능 금액은 <b
                                            className={"text-danger"}>{stringUtil.formatNumber(Math.floor(paymentInfo.balance - (paymentInfo.balance * 0.1 + Math.floor(paymentInfo.amount * 1.1) * 0.03 + 500)))} 원</b> 입니다.
                                        </li>
                                    </ol>
                                    {paymentInfo.cmpnProcess && <li className={"text-danger"}>진행중인 캠페인 포함되어 캠페인이 끝날때 까지 환불을 하실 수 없습니다!</li>}
                                </div>
                        )
                    ) : (
                        <div className="info-content-item shadow">
                            <ol className="fs-6 mb-2 fw-modal fs-4 ps-4 ps-sm-5">
                                <li>본 패키지는 500건씩 총 6회에 걸쳐 진행되며, 첫 캠페인 집행 건을 기준으로 나머지 잔여 캠페인에 대하여 자동 발송을 도와주는 서비스 입니다.</li>
                                <li><b className={"text-danger"}>유효 기간 및 만료 기한을 잘 확인해 주시기 바랍니다.</b></li>
                                <li><b className={"text-danger"}>패키지 요금제의 목표 발송 가능 일자는 구매일로부터 90일 이내까지 설정 가능합니다.</b></li>
                                <li>유효 기간 : <b
                                    className={"text-danger"}>{paymentInfo.campaignExpireDate?.slice(0, 10)}</b>
                                </li>
                                <li>만료 기한 : <b
                                    className={"text-danger"}>{paymentInfo.expireDate?.slice(0, 10)}</b></li>
                                <li>패키지에 대하여 궁금하신 내용은 FAQ>서비스 혹은 1:1문의를 통해 확인해주세요.</li>
                            </ol>
                            {paymentInfo.cmpnProcess && <li className={"text-danger"}>진행중인 캠페인 포함되어 캠페인이 끝날때 까지 환불을 하실 수 없습니다!</li> }
                            { !paymentInfo.cmpnProcess && paymentInfo.refundable && (
                                <li>환불 가능 금액은 <b
                                    className={"text-danger"}>{stringUtil.formatNumber(refundAmount)} 원</b> 입니다.
                                </li>)}

                            <div className="d-flex justify-content-end mt-3">
                                <button
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => setShowTermsModal(true)}
                                >
                                    규정 확인하기
                                </button>
                            </div>
                        </div>)
                    }
                    <div className='table-responsive mt-4' style={{maxHeight: '400px', overflowY: 'scroll'}}>
                        <table className="table table-bordered">
                            <thead className='table-light'>
                            <tr>
                                <th>일시</th>
                                <th>메시지 명</th>
                                <th>서비스</th>
                                <th>구분</th>
                                <th>캠페인 건수</th>
                                <th>잔여 건수</th>
                                <th>포인트</th>
                                <th>처리 후 잔여 포인트</th>
                            </tr>
                            </thead>
                            <tbody>
                            {usageList.length === 0 ? (
                                <tr>
                                    <td colSpan="8" className="text-center">NO Data</td>
                                </tr>
                            ) : (
                                usageList.map((item, index) => (
                                    <tr key={index}>
                                        <td className='text-center'>{item.date.slice(0, 10)}</td>
                                        <td>{item.name}</td>
                                        <td className='text-center'>{item.sendChannel}</td>
                                        <td className='text-center'>{getType(item.type)}</td>
                                        <td className='text-end'>{stringUtil.formatNumber(item.sndCnt)} 건</td>
                                        <td className='text-end'>{stringUtil.formatNumber(item.balance)} 건</td>
                                        <td className='text-end'>{stringUtil.formatNumber(item.pointAmount)} p</td>
                                        <td className='text-end'>{stringUtil.formatNumber(item.pointBalance)} p</td>
                                    </tr>
                                ))
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='modal-footer'>
                    {paymentInfo.refundable && !paymentInfo.cmpnProcess && (
                        <button className='btn btn-outline-danger btn-md' onClick={handleRefund}>
                            환불신청
                        </button>
                    )}
                </div>
                <PackageHistoryTermsModal
                    isOpen={showTermsModal}
                    handleClose={() => setShowTermsModal(false)}
                />
            </Modal>
        )
    }
}

export default PackagePaymentUsageModal;
